import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {
  setSearchQuery,
  setSearchValue,
  setStatus,
  setType,
  setSorting,
  setCheckedItems,
  clearFilters,
  setIsRecurring,
} from '../../store/notificationsTabSlice';

// Actions for notifications table
export const notificationActions = {
  deleteSelected: async (selectedItems, dispatch, fetchNotifications, ...fetchParams) => {
    if (selectedItems.length === 0) {
      alert('Nie zaznaczono żadnych kampanii.');
      return;
    }

    if (!window.confirm(`Czy na pewno chcesz usunąć ${selectedItems.length} kampanię(ń)?`)) {
      return;
    }

    try {
      const ApiService = (await import('../../components/api_services/apiService.jsx')).default;
      // Delete notifications one by one (API doesn't support bulk delete)
      for (const id of selectedItems) {
        await ApiService.deleteNotification(id);
      }
      dispatch(setCheckedItems([]));
      // Refresh the campaigns list
      fetchNotifications(...fetchParams);
      alert('Kampanie zostały usunięte.');
    } catch (error) {      
      console.error('Błąd podczas usuwania kampanii:', error);
      alert('Wystąpił błąd podczas usuwania kampanii.');
    }
  },
};

// Configuration for table headers
export const getHeaders = (
  sortBy,
  sortDirection,
  dispatch,
  setSorting,
  sortArrowColorActive,
  sortArrowColorInactive,
  rowsNotifications,
  checkedItems,
  notificationsData,
  setCheckedItems
) => [
  <input
    key="select-all"
    type="checkbox"
    checked={
      notificationsData &&
      notificationsData.length > 0 &&
      notificationsData.every((notif) => checkedItems.includes(notif.id))
    }
    onChange={(e) => {
      if (e.target.checked && notificationsData) {
        // Select all visible notifications
        dispatch(setCheckedItems([...notificationsData.map((n) => n.id)]));
      } else {
        // Deselect all
        dispatch(setCheckedItems([]));
      }
    }}
    />,
  <div key="title-header" className="table-columns-headers">
    <div>Tytuł</div>
    <SortArrows
      upColor={sortBy === 'title' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'title' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'title') {
          dispatch(setSorting({ sortBy: 'title', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'title', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  'Wiadomość',
  <div key="target-users-header" className="table-columns-headers">
    <div>Użytkownicy docelowi</div>
    <SortArrows
      upColor={sortBy === 'targetUserCount' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'targetUserCount' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'targetUserCount') {
          dispatch(setSorting({ sortBy: 'targetUserCount', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'targetUserCount', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="total-sent-header" className="table-columns-headers">
    <div>Wysłano łącznie</div>
  </div>,
  <div key="firebase-sent-header" className="table-columns-headers">
    <div>Firebase</div>
  </div>,
  <div key="rabbitmq-sent-header" className="table-columns-headers">
    <div>RabbitMQ</div>
  </div>,
  <div key="date-header" className="table-columns-headers">
    <div>Data utworzenia</div>
    <SortArrows
      upColor={sortBy === 'createdAt' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'createdAt' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'createdAt') {
          dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'ASC' }));
          }
        }
      }}
    />
  </div>,
  <div key="status-header" className="table-columns-headers">
    <div>Status</div>
    <SortArrows
      upColor={sortBy === 'status' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'status' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'status') {
          dispatch(setSorting({ sortBy: 'status', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'status', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="type-header" className="table-columns-headers">
    <div>Typ</div>
    <SortArrows
      upColor={sortBy === 'type' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'type' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'type') {
          dispatch(setSorting({ sortBy: 'type', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'type', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="actions-header">Akcje</div>,
];

// Column widths - matching documents table format
export const headerWidths = [
  '42px', // checkbox
  'minmax(150px, 2fr)', // Tytuł
  'minmax(250px, 3fr)', // Wiadomość
  'minmax(150px, 2fr)', // Użytkownicy docelowi
  'minmax(100px, 1fr)', // Wysłano łącznie
  'minmax(80px, 1fr)', // Firebase
  'minmax(80px, 1fr)', // RabbitMQ
  'minmax(140px, 2fr)', // Data utworzenia
  'minmax(100px, 1fr)', // Status
  'minmax(100px, 1fr)', // Typ
  'minmax(120px, 1fr)', // Akcje
];

// Filter options
export const statusFilterOptions = [
  { value: '', label: 'Wszystkie statusy' },
  { value: 'ACTIVE', label: 'Aktywne' },
  { value: 'DELETED', label: 'Usunięte' },
];

export const typeFilterOptions = [
  { value: '', label: 'Wszystkie typy' },
  { value: 'SINGULAR', label: 'Pojedyncze' },
  { value: 'RECURRING', label: 'Powtarzające się' },
];

export const recurringFilterOptions = [
  { value: '', label: 'Wszystkie' },
  { value: 'true', label: 'Tak' },
  { value: 'false', label: 'Nie' },
];

// Buttons configuration
export const buttonsConfig = (handleToggleAddModal) => [
  {
    icon: AddIcon,
    name: 'Dodaj powiadomienie',
    baseClass: 'custom-button-blue',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      handleToggleAddModal();
    },
    toggleActive: false,
  },
];

// Left side configuration (filters)
export const leftSideConfig = (dispatch, status, type, isRecurring, searchValue, setSearchQuery) => [
  <CustomInput
    key="search"
    placeholder="Wyszukaj..."
    value={searchValue}
    onChange={(e) => {
      dispatch(setSearchValue(e.target.value));
    }}
    onKeyPress={(e) => {
      if (e.key === 'Enter') {
        dispatch(setSearchQuery(e.target.value || null));
      }
    }}
    icon={<SearchIcon />}
    onIconClick={() => {
      dispatch(setSearchQuery(searchValue || null));
    }}
  />,
  <select
    key="status-filter"
    value={status || ''}
    onChange={(e) => {
      dispatch(setStatus(e.target.value || null));
    }}
    style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
  >
    {statusFilterOptions.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>,
  <select
    key="type-filter"
    value={type || ''}
    onChange={(e) => {
      dispatch(setType(e.target.value || null));
    }}
    style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
  >
    {typeFilterOptions.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>,
  <select
    key="recurring-filter"
    value={isRecurring !== null ? String(isRecurring) : ''}
    onChange={(e) => {
      const value = e.target.value;
      dispatch(setIsRecurring(value === '' ? null : value === 'true'));
    }}
    style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
  >
    {recurringFilterOptions.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>,
];

// Right side configuration (buttons)
export const rightSideConfig = (dispatch, checkedItems, fetchNotifications, ...fetchParams) => [
  <CustomButton
    key="delete-button"
    label="Usuń zaznaczone"
    icon={Trash}
    onClick={() => {
      notificationActions.deleteSelected(checkedItems, dispatch, fetchNotifications, ...fetchParams);
    }}
    disabled={checkedItems.length === 0}
  />,
];

export const empty = 'Brak kampanii';
